import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sgke131aResponseReconciliationResult } from 'sg-api';

@Component({
  selector: 'app-sgke130d-reconciliation-result',
  templateUrl: './sgke130d-reconciliation-result.component.html',
  styleUrl: './sgke130d-reconciliation-result.component.scss'
})
export class Sgke130dReconciliationResultComponent implements OnInit, OnDestroy {
  /** 突合結果 */
  @Input() reconciliationResult: Sgke131aResponseReconciliationResult;
  /** データソース */
  dataSource: MatTableDataSource<Sgke131aResponseReconciliationResult>;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'receivemoneyyoteiMny',
    'kouzaDepositreportAmt',
    'feeTotalamountAmt',
    'kafusokuMny',
  ];

  /**
   * 初期処理
   * 
   * @memberof Sgke130dReconciliationResultComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke131aResponseReconciliationResult>([this.reconciliationResult]);
  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dReconciliationResultComponent
   */
  ngOnDestroy(): void {
  }

}
